import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft, Calendar, Clock, Share2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CMFelicitationImage from "../../../assets/images/harsh-cm-amreli.jpg";

const CMFelicitationPost = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex items-center justify-between mb-8">
          <motion.button
            onClick={() => navigate("/articles/blog")}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center text-red-600 hover:text-red-700 group"
          >
            <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
            Back to Blog
          </motion.button>
          <motion.button
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={() => navigator.share?.({ title: document.title, url: window.location.href })}
            className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <Share2 className="w-4 h-4" />
            Share
          </motion.button>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex flex-wrap items-center gap-4 mb-6">
            <span className="px-4 py-1.5 bg-red-100 text-red-600 rounded-full text-sm font-medium">
              Recognition
            </span>
            <div className="flex items-center text-gray-500 text-sm">
              <Calendar className="w-4 h-4 mr-1.5" />
              September 2025
            </div>
            <div className="flex items-center text-gray-500 text-sm">
              <Clock className="w-4 h-4 mr-1.5" />
              3 min read
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            CM Felicitates Me as ICA Youth President at Amreli
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
            After my election in the International Cooperative Alliance (ICA) Youth Committee, the Honourable Chief Minister of Gujarat, Bhupendra Patel, felicitated me at an event in Amreli
          </p>

          <div className="mb-12 -mx-4 sm:mx-0">
            <img
              src={CMFelicitationImage}
              alt="CM Felicitation at Amreli - ICA Youth President"
              className="w-full rounded-none sm:rounded-xl shadow-2xl"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              After my election in the International Cooperative Alliance (ICA) Youth Committee, the Honourable Chief Minister of Gujarat, Bhupendra Patel, felicitated me at an event in Amreli, which was also attended by my uncle, Shri Dileep Sanghani.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              I had the opportunity to brief the Chief Minister about my work and achievements at the international cooperative forum. The ICA Youth Committee is a global body representing young cooperative leaders, and through it, I am working to promote youth participation in policymaking, cooperative entrepreneurship, and leadership development through toolkits, youth forums, and exchange programs.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              I have taken on this role succeeding Spain-based Ana Aguirre. My term also aligns with the UN-declared International Year of Cooperatives 2025, which highlights the importance of youth empowerment in addressing global challenges such as climate change, economic inequality, and sustainable livelihoods.
            </p>

            <p className="text-lg text-gray-500 mt-12 mb-8">- Harsh M. Sanghani</p>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <button
                onClick={() => navigate("/articles/blog")}
                className="inline-flex items-center gap-2 px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
              >
                <ArrowLeft className="w-5 h-5" />
                Read More Articles
              </button>
            </div>
          </div>
        </motion.div>
      </article>
    </div>
  );
};

export default CMFelicitationPost;
